import React, { createContext, useContext, useEffect, useState } from 'react';
import { getDataViewsConfig } from '../services/CatalogsService';

const DataViewsContext = createContext();

export const DataViewsProvider = ({ children }) => {
  const [dataViews, setDataViews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDataViews = async () => {
      try {
        const token = localStorage.getItem('site');
        const config = await getDataViewsConfig(token);
        setDataViews(config.views || []);
      } catch (e) {
        setError(e);
        setDataViews([]);
      } finally {
        setLoading(false);
      }
    };
    fetchDataViews();
  }, []);

  return (
    <DataViewsContext.Provider value={{ dataViews, loading, error }}>
      {children}
    </DataViewsContext.Provider>
  );
};

export const useDataViews = () => useContext(DataViewsContext);
